// extracted by mini-css-extract-plugin
export default {"root":"NavGroup_root__40EsA","name":"NavGroup_name__2V7un","draggable":"NavGroup_draggable__3SpB0"};